<template>
    <div
        id="gift-card-modal"
        class="modal modal-custom-form fade"
        tabindex="-1"
        role="dialog"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div id="gift-card-code-form" class="row">
                        <div class="col">
                            <div
                                id="gift-card-warning-alert"
                                class="alert alert-warning d-none"
                            >
                                {{ warningMessage }}
                            </div>
                            <form class="form" @submit="searchGiftCard">
                                <div class="form-group">
                                    <label
                                        for="giftCartCodeInput"
                                        v-html="
                                            trans('user.cart.gift_card.code')
                                        "
                                    ></label>
                                    <input
                                        id="giftCartCodeInput"
                                        v-model="cardCodeInput"
                                        type="text"
                                        class="input-rounded"
                                        @keydown="clearErrors()"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    class="button-rounded"
                                    v-html="trans('user.cart.gift_card.search')"
                                ></button>
                            </form>
                        </div>
                    </div>
                    <div id="gift-card-amount-form" class="row d-none">
                        <div class="col">
                            <div class="card bg-light mb-4">
                                <div class="card-body">
                                    <h3>
                                        <span
                                            v-html="
                                                trans(
                                                    'user.cart.gift_card.number'
                                                )
                                            "
                                        ></span
                                        ><span id="gift-card-code">{{
                                            giftCard.code
                                        }}</span>
                                    </h3>
                                    <h4>
                                        <span
                                            v-html="
                                                trans(
                                                    'user.cart.gift_card.available_amount'
                                                )
                                            "
                                        ></span>
                                        <span id="gift-card-amount">{{
                                            formatPrice(
                                                giftCard.amount,
                                                giftCard.currency.code
                                            )
                                        }}</span>
                                    </h4>
                                </div>
                            </div>
                            <form @submit="applyGiftCard">
                                <div class="form-group">
                                    <label
                                        for="amountInput"
                                        v-html="
                                            trans('user.cart.gift_card.amount')
                                        "
                                    ></label>
                                    <input
                                        id="amountInput"
                                        class="input-rounded"
                                        v-model="cardAmountInput"
                                        type="number"
                                        min="0"
                                        step="1"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    class="button-rounded"
                                    v-html="trans('user.cart.gift_card.apply')"
                                ></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';

export default {
    data() {
        return {
            giftCard: {
                code: null,
                amount: null,
                currency: {},
            },
            cardCodeInput: null,
            cardAmountInput: null,
            warningMessage: '',
        };
    },

    components: {},

    mounted() {
        $('#gift-card-modal').on('show.bs.modal', () => {
            this.clearErrors();
            $('#gift-card-amount-form input').focus();
        });
    },

    methods: {
        formatPrice(price, currencyCode) {
            if (currencyCode != undefined && currencyCode != undefined) {
                return window.app.formatPrice(price, currencyCode);
            } else {
                return '';
            }
        },

        searchGiftCard(e) {
            // Prevent submit with no value
            if (this.cardCodeInput != null && this.cardCodeInput != '') {
                // Look for the gift card
                axios
                    .get('/api/carts/gift-cards/check/' + this.cardCodeInput, {
                        headers: {
                            'X-CSRF-TOKEN': this.$parent.token,
                        },
                    })
                    .then(
                        (success) => {
                            // --- If found ---
                            if (success.data.success) {
                                // hide error alert
                                $('#gift-card-warning-alert').addClass(
                                    'd-none'
                                );

                                // 1/ setup gift card info
                                this.giftCard = success.data.data;

                                // 2/ hide search form
                                $('#gift-card-code-form').addClass('d-none');

                                // 3/ show amount form
                                $('#gift-card-amount-form').removeClass(
                                    'd-none'
                                );
                                $('#gift-card-amount-form input').focus();
                            } else {
                                // --- If not found ---
                                // 1/ setup alert #gift-card-warning-alert message
                                this.warningMessage = this.trans(
                                    success.data.message,
                                    { ':code': success.data.data }
                                );

                                // 2/ display error alert
                                $('#gift-card-warning-alert').removeClass(
                                    'd-none'
                                );

                                // 3/ hide amount form
                                $('#gift-card-amount-form').addClass('d-none');
                            }
                        },
                        (error) => {
                            this.hideModal();
                            // Handle error
                            this.$parent.$refs.alertBox.handleError(error);
                        }
                    );
            }

            // Avoid form submission
            e.preventDefault();
        },

        applyGiftCard(e) {
            // 1/ use the gift card using api call
            axios
                .post(
                    '/api/carts/gift-cards/use',
                    {
                        id: this.giftCard.id,
                        amount: this.cardAmountInput,
                    },
                    {
                        headers: {
                            'X-CSRF-TOKEN': document.querySelector(
                                'meta[name="csrf-token"]'
                            ).content,
                        },
                    }
                )
                .then(
                    (success) => {
                        if (success.data.success) {
                            // Update global data for further events.
                            appData.page.vars.gtmData = {
                                ...success.data.gtmData,
                                ...{
                                    amount: this.cardAmountInput,
                                    code: this.cardCodeInput,
                                    id: this.giftCard.id,
                                },
                            };

                            // Trigger GTM event.
                            this.app.gtm.trigger(
                                'applyGiftCard',
                                appData.page.vars.gtmData
                            );

                            // 2/ reload cart with amount of the gift card removed
                            this.$parent.loadCart();
                            this.$parent.$refs.alertBox.showAlertMessage(
                                'success',
                                this.trans(success.data.message, {
                                    ':code': success.data.data,
                                })
                            );
                        } else {
                            // Show warning message
                            if (success.data.data) {
                                this.$parent.$refs.alertBox.showAlertMessage(
                                    'warning',
                                    this.trans(success.data.message, {
                                        ':code': success.data.data,
                                    })
                                );
                            } else {
                                this.$parent.$refs.alertBox.showAlertMessage(
                                    'warning',
                                    this.trans(success.data.message)
                                );
                            }
                        }
                    },
                    (error) => {
                        // Handle error and show the user a message
                        this.$parent.$refs.alertBox.handleError(error);
                    }
                );

            // 3/ hide the modal
            this.hideModal();

            // 4/ setup modal for next open if needed
            $('#gift-card-warning-alert').addClass('d-none');
            $('#gift-card-code-form').removeClass('d-none');
            $('#gift-card-amount-form').addClass('d-none');

            // Avoid form submission
            e.preventDefault();
        },

        clearErrors() {
            $('#gift-card-warning-alert').addClass('d-none');
        },

        hideModal() {
            document.getElementById('gift-card-modal').classList.remove('show');
            document.body.classList.remove('modal-open');
            $('.modal-backdrop').remove();
        },
    },
};
</script>
